var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VueCropper',{ref:"cropper",attrs:{"src":_vm.imageUrl,"view-mode":1,"drag-mode":"move","aspect-ratio":_vm.aspectRatio,"guides":false,"background":false,"img-style":_vm.imgStyle,"min-container-width":_vm.minContainerWidth,"min-container-height":_vm.minContainerHeight,"crop-box-movable":false,"crop-box-resizable":false,"toggle-drag-mode-on-dblclick":false,"modal":false,"check-cross-origin":false,"ready":function () {
      _vm.onReadyCropper(this$1.$refs.cropper);
    }}})}
var staticRenderFns = []

export { render, staticRenderFns }